import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContainerQuality, CardContent, CircleChart, TextContainer, Title, ProgressStyles } from './styles';

const QualityCard = ({ data, device }) => {
  const isMobile = device === 'mobile';
  const isPenalized = data?.validations?.some(v => v.rule_id === 'deployment');
  const isDuplicated = data?.validations?.some(v => v.rule_id === 'duplicate');
  const { t } = useTranslation();

  const { percentage_correctness, quality_status, validations } = data || {};
  const isFull = percentage_correctness === '100';
  const qualityStatus = quality_status || 'not_apply';
  const valueQuality = percentage_correctness || '0';
  const qualityNotApply = qualityStatus === 'not_apply';
  const isLoading = qualityStatus === 'loading';
  const noData = qualityNotApply || isLoading;

  const getTextInsideCircle = value => {
    if (isPenalized) {
      return (
        <text data-panel='quality-noData' x='18' y='20.35' className='label'>
          {t('panel.avisos.posting.quality.penalized')}
        </text>
      );
    }
    if (isDuplicated) {
      return (
        <text data-panel='quality-noData' x='18' y='20.35' className='label'>
          {t('panel.avisos.posting.quality.duplicated')}
        </text>
      );
    }
    if (qualityNotApply) {
      return (
        <text data-panel='quality-notApply' x='18' y='20.35' className='label'>
          {t('professionalPubli.edition.quality.notApply')}
        </text>
      );
    }
    if (!value || (typeof value === 'number' && value === 0) || isLoading) {
      return (
        <text data-panel='quality-noData' x='18' y='20.35' className='label'>
          {t('professionalPubli.edition.quality.noData')}
        </text>
      );
    }
    return (
      <text data-panel='quality-valuePercentage' x='18' y='21.3' className='percentage'>
        {Math.round(value)}%
      </text>
    );
  };

  const getTextTitle = status => {
    if (isFull) return t('professionalPubli.edition.quality.title.full');
    if (status === 'loading') return t('professionalPubli.edition.quality.title.loading');
    if (status === 'not_apply') return t('professionalPubli.edition.quality.title.noData');
    return t('professionalPubli.edition.quality.title.upgrade');
  };

  return (
    <CardContent device={device} centerRow={noData || isFull}>
      <ContainerQuality
        device={device}
        qualityStatus={isPenalized || isDuplicated ? 'not_apply' : qualityStatus}
        centerRow={noData || isFull}
      >
        <CircleChart
          data-panel='quality-circleChart'
          qualityStatus={isPenalized || isDuplicated ? 'not_apply' : qualityStatus}
          isFull={isFull}
          qualityNotApply={qualityNotApply}
        >
          <div className='single-chart'>
            <svg viewBox='0 0 36 36' className='circular-chart'>
              <path
                className='circle-bg'
                data-publi={`quality-color-${ProgressStyles[isPenalized || isDuplicated ? 'not_apply' : qualityStatus]
                  ?.barColor || ''}`}
                d='M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831'
              />
              <path
                data-publi={`quality-value-${Math.round(valueQuality)}`}
                className='circle'
                strokeDasharray={`${Math.round(valueQuality)}, 100`}
                d='M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831'
              />
              {getTextInsideCircle(valueQuality)}
            </svg>
          </div>
          <div className='icon-container'>
            <div className='face-icon' />
          </div>
        </CircleChart>
        {isMobile && <Title data-panel='quality-circleChart-title'>{getTextTitle(qualityStatus)}</Title>}
      </ContainerQuality>
      <TextContainer>
        {!isMobile && <Title data-panel='quality-circleChart-title'>{getTextTitle(qualityStatus)}</Title>}
        {(!noData || !isFull) && validations?.length > 0 && (
          <div className='textWrapper'>
            {validations.map((item, index) => (
              <React.Fragment key={item.advice}>
                <div className='text' data-panel={`quality-advice-${index}`}>
                  <div>•</div>
                  {item.advice}
                </div>
              </React.Fragment>
            ))}
          </div>
        )}
      </TextContainer>
    </CardContent>
  );
};

export default QualityCard;
